// crypto.randomUUID is secure-context-only (HTTPS or localhost) — undefined on
// plain-http origins like backoffice.test. Fall back to crypto.getRandomValues,
// which IS available in insecure contexts, to build a v4 UUID.
export function generateUuid() {
  if (self.crypto && typeof self.crypto.randomUUID === "function") {
    return self.crypto.randomUUID();
  }
  const b = new Uint8Array(16);
  self.crypto.getRandomValues(b);
  b[6] = (b[6] & 0x0f) | 0x40; // version 4
  b[8] = (b[8] & 0x3f) | 0x80; // variant
  const h = [...b].map((x) => x.toString(16).padStart(2, "0"));
  return `${h.slice(0, 4).join("")}-${h.slice(4, 6).join("")}-${h.slice(6, 8).join("")}-${h.slice(8, 10).join("")}-${h.slice(10, 16).join("")}`;
}
